import styled from 'styled-components';

import {ReactEventHandler, ReactNode} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

interface CheckboxProps extends TestIdProps {
  name?: string;
  label?: string | ReactNode;
  checked?: boolean;
  onChange?: ReactEventHandler;
}

export function MakeCheckbox(props: CheckboxProps) {
  const {label, name, ...rest} = props;

  return (
    <Wrapper data-testid={suffixTestId(`wrapper`, props)}>
      <Input id={name} type="checkbox" data-testid={suffixTestId(`input`, props)} {...rest} />
      <Label htmlFor={name} data-testid={suffixTestId(`label`, props)}>
        {label}
      </Label>
    </Wrapper>
  );
}

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
const Label = styled.label`
  cursor: pointer;
  position: relative;
  display: inline-flex;
  margin-right: 7px;
  margin-bottom: 11px;
  border-radius: ${({theme}) => theme.radii.small};

  &:hover {
    border-radius: ${({theme}) => theme.radii.small};
    box-shadow: 0 0 0 4px ${({theme}) => theme.colors.palettes.blue[20][100]};
  }
`;

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
const Input = styled.input`
  height: 0;
  width: 0;
  opacity: 0;
  position: absolute;

  &:checked {
    + ${Label} {
      > div {
        border: 1px solid ${({theme}) => theme.colors.palettes.blue[60][100]};
        background-color: ${({theme}) => theme.colors.palettes.blue[20][100]};
      }
    }
  }
`;

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
const Wrapper = styled.div`
  position: relative;

  &:nth-child(4n) label {
    margin-right: 0px;
  }
`;
